/** Tool status for artifact/tool result display. */
export enum TOOL_STATUS {
    SUCCESS = 'success',
    ERROR = 'error',
    LOADING = 'loading'
}